import { render, staticRenderFns } from "./list-regular.vue?vue&type=template&id=9d275616"
import script from "./list-regular.vue?vue&type=script&lang=js"
export * from "./list-regular.vue?vue&type=script&lang=js"
import style0 from "./list-regular.vue?vue&type=style&index=0&id=9d275616&prod&lang=scss&scope=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports